module.exports = __webpack_public_path__ + "img/juhend-img.a5127d20.png";